"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Row = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uuid = require("uuid");

var _atoms = require("../../../atoms");

var _Table = require("../Table.style");

var _images = require("../../../assets/images");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const Row = ({
  columns,
  showIndex,
  isSelectable,
  collapse,
  collapseOnRowClick,
  data,
  index,
  checkColumnHasChild,
  handleRowClick,
  handleRowCollapse,
  handleRowMouseEnter,
  handleRowMouseLeave,
  handleRowSelection,
  handleRename,
  rowClassName,
  cellClassName
}) => {
  const handleOnRowClick = (0, _react.useCallback)(e => {
    handleRowClick(e, data);
    collapseOnRowClick && handleRowCollapse(index);
  }, [data, collapseOnRowClick, handleRowClick, handleRowCollapse]);
  const handleOnRowCollapse = (0, _react.useCallback)(e => {
    if (!collapseOnRowClick) {
      e.stopPropagation();
      handleRowCollapse(index);
    }
  }, [collapseOnRowClick, handleRowCollapse]);
  return /*#__PURE__*/_react.default.createElement(_Table.StyledRow, {
    "data-testid": `row-${index}`,
    className: rowClassName,
    showOutline: collapse[index] === true,
    onClick: handleOnRowClick,
    onMouseEnter: e => handleRowMouseEnter(e, index),
    onMouseLeave: e => handleRowMouseLeave(e, index)
  }, showIndex && /*#__PURE__*/_react.default.createElement(_Table.StyledCell, {
    isSelectable: isSelectable,
    showIndex: showIndex,
    className: cellClassName,
    onClick: e => e.stopPropagation()
  }, isSelectable ? /*#__PURE__*/_react.default.createElement(_Table.CheckboxWrapper, null, /*#__PURE__*/_react.default.createElement(_atoms.Checkbox, {
    name: (0, _uuid.v4)(),
    checked: !data._isDisable && data._isCheck,
    value: '' + index,
    onChange: e => handleRowSelection(e, index),
    "data-testid": `select-checkbox-${index}`,
    disabled: data._isDisable,
    isPartial: data._isPartial ? data._isPartial : false
  })) : /*#__PURE__*/_react.default.createElement("span", null, index + 1)), collapse.length !== 0 && /*#__PURE__*/_react.default.createElement(_Table.StyledCell, {
    "data-testid": `expansion-arrow-${index + 1}`,
    className: `expansion-cell ${cellClassName} ${collapse[index] && 'rotate-caret'}`
  }, checkColumnHasChild(index) && /*#__PURE__*/_react.default.createElement(_images.DownArrow, {
    "data-testid": `collapse-chevron-${index + 1}`,
    onClick: handleOnRowCollapse
  })), columns.map(({
    accessor,
    render
  }, j) => {
    return render !== undefined ? /*#__PURE__*/_react.default.createElement(_Table.StyledCell, {
      key: j,
      className: cellClassName,
      isCollapse: collapse.length !== 0
    }, render(data, handleRename)) : /*#__PURE__*/_react.default.createElement(_Table.StyledCell, {
      key: j,
      className: cellClassName,
      isCollapse: collapse.length !== 0
    }, data[accessor]);
  }));
};

exports.Row = Row;
Row.propTypes = {
  columns: _propTypes.default.arrayOf(_propTypes.default.object),
  showIndex: _propTypes.default.bool,
  isSelectable: _propTypes.default.bool,
  collapse: _propTypes.default.array,
  collapseOnRowClick: _propTypes.default.bool,
  data: _propTypes.default.object,
  index: _propTypes.default.number,
  checkColumnHasChild: _propTypes.default.func,
  handleRowClick: _propTypes.default.func,
  handleRowCollapse: _propTypes.default.func,
  handleRowMouseEnter: _propTypes.default.func,
  handleRowMouseLeave: _propTypes.default.func,
  handleRowSelection: _propTypes.default.func,
  handleRename: _propTypes.default.func,
  rowClassName: _propTypes.default.string,
  cellClassName: _propTypes.default.string
};